import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import {
  TableWrapper,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  FooterButton
} from './styles/Table.styles';
import { ensurePxUnit } from '../utils/mobileUtils';

const TableControl = ({ control, renderMode }) => {
  const rowHeight = control.rowHeight || 25;
  const placeholderRows = [...Array(2)];

  const totalTableWidth = control.columns.reduce((sum, col) => sum + (parseFloat(col.width) || 0), 0);

  const getColumnWidth = (colWidth) => {
    if (renderMode === 'preview') {
      return ensurePxUnit(colWidth);
    }

    return totalTableWidth > 0
      ? `${((parseFloat(colWidth) || 0) / totalTableWidth) * 100}%`
      : 'auto';
  };

  return (
    <ObjectWrapper>
      <TableWrapper styleProps={control.attributes}>
        {control.showHeader && (
          <TableHeader styleProps={control.attributes} headerHeight={control.headerHeight} renderMode={renderMode}>
            {control.columns.map(col => (

              <TableHeaderCell
                key={col.header}
                width={getColumnWidth(col.width)}
                borderColor={control.attributes.borderColor}
              >
                {col.header}
              </TableHeaderCell>
            ))}
          </TableHeader>
        )}
        <TableBody>
          {placeholderRows.map((_, rowIndex) => (
            <TableRow key={rowIndex} styleProps={control.attributes} rowHeight={rowHeight}>
              {control.columns.map(col => (
                <TableCell
                  key={`${rowIndex}-${col.header}`}
                  width={getColumnWidth(col.width)}
                  borderColor={control.attributes.borderColor}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
        {control.buttons === 'bottom' && (
          <TableFooter styleProps={control.attributes}>
            <FooterButton title="Add Row">
              <i className="fa pf-add" />
            </FooterButton>
            <FooterButton title="Delete Row">
              <i className="fa pf-delete icon-gradient" />
            </FooterButton>
          </TableFooter>
        )}
      </TableWrapper>
    </ObjectWrapper>
  );
};

export default TableControl;